import { takeLatest, put, call } from "redux-saga/effects";
import { sagaActions } from "../../actions";
import {
  searchParticipantsRequests,
  searchParticipantsRequestsCompleted,
} from "../../slices/participants-requests";
import { workflowsService } from "../../../../../src/core/workflows/workflows_service";

async function handleSearchParticipantsRequests({ page, items, filters }) {
  return await workflowsService.listCurrentParticipantsRequest(
    page,
    items,
    filters
  );
}

async function handleGetUsers({ tokens, page, items, filters }) {
  return await workflowsService.listUsers(tokens, page, items, filters);
}

function* searchParticipantsRequestsSaga({ payload }) {
  try {
    yield put(searchParticipantsRequests({ term: payload.filters }));
    const participantsRequestsData = yield call(
      handleSearchParticipantsRequests,
      payload
    );
    const usersTokens = participantsRequestsData.data.map(
      (item) => item.user_token
    );
    const { data: usersData } = yield call(handleGetUsers, {
      tokens: usersTokens,
      page: 1,
      items: 10,
      filters: {},
    });

    participantsRequestsData.data = participantsRequestsData.data.map(
      (item) => {
        const user = usersData.find((user) => user.token === item.user_token);
        return {
          ...item,
          fullName: `${user.name} ${user.last_name}`,
        };
      }
    );
    yield put(searchParticipantsRequestsCompleted(participantsRequestsData));
  } catch (error) {
    console.error(error.message);
  }
}

export function* searchParticipantsRequestsWatcherSaga() {
  yield takeLatest(
    sagaActions.START_SEARCH_LIST_PARTICIPANTS_REQUESTS,
    searchParticipantsRequestsSaga
  );
}
